"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualLibrary = void 0;
/**
 * import { default as LftVirtualLibraryIcon } from '@lift/assets/dist/assets/icons/virtual_library';
 * import LftIconBase from '@lift/design-system-react-web/dist/components/LftIconBase';
 */
var react_1 = __importDefault(require("react"));
var icon_wrapper_lift_1 = require("../icon-wrapper-lift");
var virtual_library_icon_1 = __importDefault(require("./virtual-library-icon"));
var virtual_library_icon_temporary_styles_1 = require("./virtual-library-icon.temporary.styles");
/**
 *
 * @description
 * Após o Lift disponibilizar o icone correto, o arquivo "virtual-library-icon.temporary.styles" e
 * o bloco a seguir deve ser removido.
 * @example
 *  <VirtualLibraryFixTemporaryStyled>
 *    <VirtualLibraryIcon {...props} />
 *   </VirtualLibraryFixTemporaryStyled>
 * [Importante]: depois da disponibilidade do icone o código lift comentado deve ser descomentado também.
 */
var VirtualLibrary = function (props) {
    return (react_1.default.createElement(icon_wrapper_lift_1.IconWrapperLiftStyled, { size: props.size },
        react_1.default.createElement(virtual_library_icon_temporary_styles_1.VirtualLibraryFixTemporaryStyled, null,
            react_1.default.createElement(virtual_library_icon_1.default, __assign({}, props)))));
};
exports.VirtualLibrary = VirtualLibrary;
